export const ADD_LIST_ITEM_REQUEST = 'ADD_LIST_ITEM_REQUEST';
export const ADD_LIST_ITEM_SUCCESS = 'ADD_LIST_ITEM_SUCCESS';
export const ADD_LIST_ITEM_ERROR = 'ADD_LIST_ITEM_ERROR';

export const REMOVE_LIST_ITEM_REQUEST = 'REMOVE_LIST_ITEM_REQUEST';
export const REMOVE_LIST_ITEM_SUCCESS = 'REMOVE_LIST_ITEM_SUCCESS';
export const REMOVE_LIST_ITEM_ERROR = 'REMOVE_LIST_ITEM_ERROR';

export const RESTORE_LIST_ITEM_REQUEST = 'RESTORE_LIST_ITEM_REQUEST';
export const RESTORE_LIST_ITEM_SUCCESS = 'RESTORE_LIST_ITEM_SUCCESS';
export const RESTORE_LIST_ITEM_ERROR = 'RESTORE_LIST_ITEM_ERROR';

export const REMOVE_LIST_REQUEST = 'REMOVE_LIST_REQUEST';
export const REMOVE_LIST_SUCCESS = 'REMOVE_LIST_SUCCESS';
export const REMOVE_LIST_ERROR = 'REMOVE_LIST_ERROR';

export const RESTORE_LIST_REQUEST = 'RESTORE_LIST_REQUEST';
export const RESTORE_LIST_SUCCESS = 'RESTORE_LIST_SUCCESS';
export const RESTORE_LIST_ERROR = 'RESTORE_LIST_ERROR';

export const CREATE_LIST_REQUEST = 'CREATE_LIST_REQUEST';
export const CREATE_LIST_SUCCESS = 'CREATE_LIST_SUCCESS';
export const CREATE_LIST_ERROR = 'CREATE_LIST_ERROR';

export const RENAME_LIST_REQUEST = 'RENAME_LIST_REQUEST';
export const RENAME_LIST_SUCCESS = 'RENAME_LIST_SUCCESS';
export const RENAME_LIST_ERROR = 'RENAME_LIST_ERROR';

export const SORT_LIST = 'SORT_LIST';
export const SELECT_LIST = 'SELECT_LIST';

export const OPEN_LISTS = 'OPEN_LISTS';
export const CLOSE_LISTS = 'CLOSE_LISTS';

export const ORDER_LISTS_REQUEST = 'ORDER_LISTS_REQUEST';
export const ORDER_LIST_ITEMS_REQUEST = 'ORDER_LIST_ITEMS_REQUEST';

const addListItemRequest = (product, isDesktop) => ({
  type: ADD_LIST_ITEM_REQUEST,
  product,
  isDesktop,
});

const addListItemSuccess = (id, listId, product) => ({
  type: ADD_LIST_ITEM_SUCCESS,
  product,
  id,
  listId,
});

const addListItemError = error => ({
  type: ADD_LIST_ITEM_ERROR,
  error,
});

const removeListItemRequest = (id, listId) => ({
  type: REMOVE_LIST_ITEM_REQUEST,
  id,
  listId,
});

const removeListItemSuccess = (restoreToken, id, listId) => ({
  type: REMOVE_LIST_ITEM_SUCCESS,
  restoreToken,
  id,
  listId,
});

const removeListItemError = error => ({
  type: REMOVE_LIST_ITEM_ERROR,
  error,
});

const restoreListItemRequest = (id, restoreToken) => ({
  type: RESTORE_LIST_ITEM_REQUEST,
  restoreToken,
  id,
});

const restoreListItemSuccess = (id, restoreToken) => ({
  type: RESTORE_LIST_ITEM_SUCCESS,
  id,
  restoreToken,
});

const restoreListItemError = error => ({
  type: RESTORE_LIST_ITEM_ERROR,
  error,
});

const removeListRequest = id => ({
  type: REMOVE_LIST_REQUEST,
  id,
});

const removeListSuccess = (restoreToken, id) => ({
  type: REMOVE_LIST_SUCCESS,
  restoreToken,
  id,
});

const removeListError = error => ({
  type: REMOVE_LIST_ERROR,
  error,
});

const restoreListRequest = (id, restoreToken) => ({
  type: RESTORE_LIST_REQUEST,
  restoreToken,
  id,
});

const restoreListSuccess = (id, restoreToken) => ({
  type: RESTORE_LIST_SUCCESS,
  id,
  restoreToken,
});

const restoreListError = error => ({
  type: RESTORE_LIST_ERROR,
  error,
});

const createListRequest = listName => ({
  type: CREATE_LIST_REQUEST,
  listName,
});

const createListSuccess = list => ({
  type: CREATE_LIST_SUCCESS,
  list,
});

const createListError = error => ({
  type: CREATE_LIST_ERROR,
  error,
});

const renameListRequest = (id, name) => ({
  type: RENAME_LIST_REQUEST,
  id,
  name,
});

const renameListSuccess = list => ({
  type: RENAME_LIST_SUCCESS,
  list,
});

const renameListError = error => ({
  type: RENAME_LIST_ERROR,
  error,
});

const sortList = sort => ({
  type: SORT_LIST,
  sort,
});

const selectList = id => ({
  type: SELECT_LIST,
  id,
});

const openLists = () => ({
  type: OPEN_LISTS,
  open: true,
});

const closeLists = () => ({
  type: CLOSE_LISTS,
  open: false,
});

const orderListsRequest = listIds => ({
  type: ORDER_LISTS_REQUEST,
  listIds,
});

const orderListItemsRequest = (listId, listItemIds) => ({
  type: ORDER_LIST_ITEMS_REQUEST,
  listId,
  listItemIds,
});

export default {
  addListItemRequest,
  addListItemSuccess,
  addListItemError,

  removeListItemRequest,
  removeListItemSuccess,
  removeListItemError,

  restoreListItemRequest,
  restoreListItemSuccess,
  restoreListItemError,

  removeListRequest,
  removeListSuccess,
  removeListError,

  restoreListRequest,
  restoreListSuccess,
  restoreListError,

  createListRequest,
  createListSuccess,
  createListError,

  renameListRequest,
  renameListSuccess,
  renameListError,

  sortList,
  selectList,
  openLists,
  closeLists,

  orderListsRequest,
  orderListItemsRequest,
};
